module.exports = __webpack_public_path__ + "static/img/game-logo-evo.d9bf490.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-evo.png
// module id = brRG
// module chunks = 0 1 2 3 4 5 6